// Auto-generated normalizer for table: Identificaciones
export function identificacionesNormalize(row) {
  return {
    idIdentificacion: row.idIdentificacion ?? row.IdIdentificacion ?? row['IdIdentificacion'] ?? 0,
    idPersona: row.idPersona ?? row.IdPersona ?? row['IdPersona'] ?? 0,
    tipoIdentificacion: row.tipoIdentificacion ?? row.TipoIdentificacion ?? row['TipoIdentificacion'] ?? '',
    numero: row.numero ?? row.Numero ?? row['Numero'] ?? '',
    fechaExpedicion: row.fechaExpedicion ?? row.FechaExpedicion ?? row['FechaExpedicion'] ?? null,
    fechaVencimiento: row.fechaVencimiento ?? row.FechaVencimiento ?? row['FechaVencimiento'] ?? null,
    documentoAdjunto: row.documentoAdjunto ?? row.DocumentoAdjunto ?? row['DocumentoAdjunto'] ?? '',
    activo: row.activo ?? row.Activo ?? row['Activo'] ?? false,
  };
}
